export interface EmailJSON {
  id: string;
  sentDate: Date;
  from: Sender;
  isRead: boolean;
  subject: string;
  message: string;
  attachments?: string[];
}

interface Sender {
  key: number;
  email: string;
  fullName: string;
  avatar: string;
}

export class Email {

  constructor(
    public readonly id: string,
    public readonly sentDate: Date,
    public readonly from: Sender,
    public isRead: boolean,
    public readonly subject: string,
    public readonly message: string,
    public readonly attachments: string[] = [],
  ) {}

  read() {
    this.isRead = true;
    return this;
  }

  toJSON(): EmailJSON {
    return {
      id: this.id,
      sentDate: this.sentDate,
      from: this.from,
      isRead: this.isRead,
      subject: this.subject,
      message: this.message,
      attachments: this.attachments,
    }
  }

  static fromJSON(json: EmailJSON): Email {
    return new Email(
      json.id,
      json.sentDate,
      json.from,
      json.isRead,
      json.subject,
      json.message,
      json.attachments,
    );
  }
}